export const CLIENTS_LIST_KEY = 'CLIENTS_LIST';
export const CLIENTS_ONE_KEY = 'CLIENTS_ONE_KEY';

export const CLIENTS_RECIPIENT_LIST_KEY = 'CLIENTS_RECIPIENT_LIST_KEY';

export const BUSINESS_ACCOUNT_REQUEST_LIST_KEY = 'BUSINESS_ACCOUNT_REQUEST_LIST_KEY';
export const BUSINESS_ACCOUNT_REQUEST_ONE_KEY = 'BUSINESS_ACCOUNT_REQUEST_ONE_KEY';
